<collapsible-card title="Personal Information"
  [error]="error"
  [loading]="loading">
<div fxLayout="row" class="personal-information__row-container">
  <span fxFlex="50" class="personal-information__label">Customer Name:</span>
  <span fxFlex="50" class="personal-information__info">{{ name }}</span>
</div>
@if (info.loyaltyCardNumber) {
  <div fxLayout="row" class="personal-information__row-container">
    <span fxFlex="50" class="personal-information__label">Membership Number:</span>
    <span fxFlex="50" class="personal-information__info">{{ info.loyaltyCardNumber }}</span>
  </div>
}
@if (info.birthDate) {
  <div fxLayout="row" class="personal-information__row-container">
    <span fxFlex="50" class="personal-information__label">Birth Date:</span>
    <span fxFlex="50" class="personal-information__info">{{ info.birthDate }}</span>
  </div>
}
@if (info.phone) {
  <div fxLayout="row" class="personal-information__row-container">
    <span fxFlex="50" class="personal-information__label">Phone:</span>
    <span fxFlex="50" class="personal-information__info">
      @if (info.phone) {
        <span>{{info.phone}}</span>
      }
    </span>
  </div>
}
@if (info.preferredContact) {
  <div fxLayout="row" class="personal-information__row-container">
    <span fxFlex="50" class="personal-information__label">Contact Method:</span>
    <span fxFlex="50" class="personal-information__info">{{info.preferredContact}}</span>
  </div>
}
@if (info.kids && info.kids.length > 0) {
  <div>
    <div fxLayout="row" class="personal-information__row-container">
      <span fxFlex="50" class=personal-information__label>Legacy Kids Club:</span>
      <span fxFlex="50" class="personal-information__info">True</span>
    </div>
  </div>
}
@if (hasCommunicationPreferences) {
  <div class="personal-information__section" data-test="communication-preferences">
    <div class="personal-information__section-header">Communication Preferences</div>
    @for (pref of communicationPreferences; track pref.key) {
      <div fxLayout="row" class="personal-information__row-container">
        <span fxFlex="50" class="personal-information__label">{{ pref.label }}:</span>
        <span fxFlex="50" class="personal-information__info">{{ preferenceValue(pref.key) }}</span>
      </div>
    }
  </div>
}
</collapsible-card>
